import { Instant } from "@js-joda/core";
import { DweenTimeUnitEnum } from "utils/enums";
import { LabelLayer, ParentRect, ScadaLabel, ScadaProps } from "../scadaTypes";

export const DEFAULT_LAYER_NAME = "Default";

export const defaultLayer: LabelLayer = {
  layer: "",
  visible: true,
};

export const defaultScadaConfig: ScadaProps = {
  type: "scada",
  fontSizeScale: 2,
  truncateSize: 10,
  refreshRate: 30,
  maxDelayTime: 1,
  maxDelayTimeUnit: DweenTimeUnitEnum.MINUTES,
  showScadaSettings: true,
  useDefaultTagsSize: false,
  elements: [],
  polygons: [],
  freeTexts: [],
  labelLayers: [
    {
      layer: DEFAULT_LAYER_NAME,
      visible: true,
    },
  ],
};

export const defaultLabel: ScadaLabel = {
  identifier: "",
  xCoord: 0,
  yCoord: 0,
  fontSize: 10,
  bgColor: "#F3F5F6",
  isRound: false,
  roundSize: 36,
  highlights: [],
  type: "LABEL",
  layer: DEFAULT_LAYER_NAME,
};

export const defaultElementParameters: ParentRect = {
  width: 0,
  height: 0,
  top: 0,
  left: 0,
};

export const defaultDateTime = {
  date: Instant.now(),
  manualTime: false,
};

export const defaultFreeText = {
  text: "",
  color: "#000000",
  fontSize: 12,
  x: 0,
  y: 0,
  layer: null,
};
